import {
  InfoTip,
  Tooltip,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useNavigate } from 'react-router-dom';

export interface TabItem {
  name: string;
  display: string;
  navigateTo: string;
  tooltip?: Tooltip;
}

interface SolutionSubmissionTabsProps {
  activeTab: string;
  tabs: TabItem[];
  disabled?: string[];
}

export const SolutionSubmissionTabs: React.FunctionComponent<
  SolutionSubmissionTabsProps
> = ({ activeTab, tabs, disabled = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row mb-4">
      {tabs.map((tab) => {
        const isValidDisabledTab =
          activeTab !== tab.name && disabled.includes(tab.name);
        return (
          <a
            className={`${
              activeTab === tab.name ? 'border-brand-blue' : 'border-gray-200'
            }
          ${isValidDisabledTab ? 'cursor-not-allowed' : 'cursor-pointer'}
          flex flex-row gap-x-2 border-b-2 px-os1-spacing pb-4`}
            data-testid={`tabbed-item-${tab.name}`}
            key={tab.name}
            onClick={
              !isValidDisabledTab ? () => navigate(tab.navigateTo) : undefined
            }
            onKeyDown={
              !isValidDisabledTab ? () => navigate(tab.navigateTo) : undefined
            }
          >
            <span
              className={`${activeTab === tab.name ? 'text-brand-blue' : ''}
            ${
              activeTab !== tab.name && disabled.includes(tab.name)
                ? 'text-gray-300'
                : ''
            }
            font-medium bg-transparent text-sm outline-none whitespace-nowrap
focus:outline-none ease-linear transition-all duration-150 `}
              id={tab.name}
            >
              {tab.display}
            </span>
            {tab.tooltip && <InfoTip id={tab.name} tip={tab.tooltip} />}
          </a>
        );
      })}
      <div className="flex flex row border-b-2 border-gray-200 pr-os1-spacing pb-4 w-full" />
    </div>
  );
};
